module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start04-642645efdef923a15ce54d453ffa35b8.png";